export default __webpack_public_path__ + "static/media/rocket.80c861be.svg";